type AnalyticsEvent = {
  name: string;
  properties?: Record<string, unknown>;
};

export function trackEvent(name: string, properties?: Record<string, unknown>) {
  if (typeof window === "undefined") return;
  const payload: AnalyticsEvent = {
    name,
    properties: {
      ...properties,
      path: window.location.pathname,
      timestamp: new Date().toISOString(),
    },
  };
  console.log(
    JSON.stringify({
      level: "info",
      message: "client_event",
      event: name,
      properties: payload.properties,
    })
  );

  try {
    const blob = new Blob([JSON.stringify(payload)], { type: "application/json" });
    if (navigator.sendBeacon) {
      navigator.sendBeacon("/api/analytics", blob);
      return;
    }
  } catch {
    // Fall back to fetch below.
  }

  fetch("/api/analytics", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
    keepalive: true,
  }).catch(() => undefined);
}
